import React from "react";

const Dummy = () => {
  return <div>Dummy Page</div>;
};

export default Dummy;
